<label class="flex items-center cursor-pointer">
  <input
    class="w-4 h-4 mr-2 text-blue-600 bg-gray-100 border-gray-300 rounded "
    type="checkbox"
    value=""
    [ngModel]="checked"
    (ngModelChange)="onNgModelChange($event)"
    [disabled]="disabled"/>
  <ng-content></ng-content>
</label>
